import React from 'react'
import {Route, Switch, Redirect, BrowserRouter as Router} from 'react-router-dom'
import {createMuiTheme, ThemeProvider} from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import {DarkModeProvider, useDarkMode} from '../DarkModeContext'
import {CityProvider} from '../CityContext'
import SignIn from './SignIn/SignIn'
import Public from './PublicPage/Public'
import NotFound from './NotFound/NotFound'
import DeliverersPersonal from "./Deliverers/Personal";
import DeliverersProgram from "./Deliverers/Program";
import DeliverersCars from "./Deliverers/Cars";
import DeliverersStatistics from "./Deliverers/Statistics";
import DeliverersBonus from "./Deliverers/Bonus";
import DeliverersSalarii from "./Deliverers/Salarii";
import Map from "./Map";
import Navbar from "../Components/Navbar";
import Orders from "../Containers/Orders"
import Notifications from "./Notifications";
import Statistics from "./Statistics";
import StatisticsNew from "./StatisticsNew";
import StatisticsV2 from "./StatisticsV2";
import Restaurants from "./Restaurants";
import InfoClient from "./InfoClient/InfoClient";
import Users from "./Users/Users";
import Invoices from "./Invoices";
import Credit from "./Credit";
import RestaurantView from "./RestaurantView/RestaurantView";
import Vouchers from "./Vouchers/Vouchers";
import AppSettingsAplicatie from "./AppSettings/Aplicatie";
import AppSettingsTaxe from "./AppSettings/Taxe";
import AppSettingsBlacklist from "./AppSettings/Blacklist";
import AppSettingsBannere from "./AppSettings/Bannere";
import AppSettingsTargeturi from "./AppSettings/Targeturi";
import AppSettingsOrase from "./AppSettings/Orase";
import AppSettingsRoata from "./AppSettings/Roata";
import Menu from "./Menu";

function AppRoutes() {
  const PrivateRoute = ({component: Component, ...rest}) => (
    <Route {...rest} render={(props) => {
      const isLoggedIn = localStorage.getItem('access_token');
      return (
        isLoggedIn
          ? <Component {...props} />
          : <Redirect to='/signin'/>
      )
    }}/>
  );

  return (
    <div style={{display: 'flex'}}>
      <Router>
        <Switch>
          <Route path="/signin" component={SignIn}/>
          <Route path='/restaurant-view/:id' component={RestaurantView} exact/>
          <Route>
            <div style={{display: 'flex', height: '98vh', flex: 1}}>
              <Navbar/>
              <Switch>
                <PrivateRoute path='/' component={() => (<Redirect to='/dashboard'/>)} exact/>
                <PrivateRoute path='/dashboard' component={Public} exact/>
                <PrivateRoute path='/deliverers' component={() => (<Redirect to='/deliverers/personal'/>)} exact/>
                <PrivateRoute path='/deliverers/personal' component={DeliverersPersonal} exact/>
                <PrivateRoute path='/deliverers/program' component={DeliverersProgram} exact/>
                <PrivateRoute path='/deliverers/masini' component={DeliverersCars} exact/>
                <PrivateRoute path='/deliverers/harta' component={Map} exact/>
                <PrivateRoute path='/deliverers/statistici' component={DeliverersStatistics} exact/>
                <PrivateRoute path='/deliverers/bonus' component={DeliverersBonus} exact/>
                <PrivateRoute path='/deliverers/salarii' component={DeliverersSalarii} exact/>
                <PrivateRoute path='/info-client' component={InfoClient} exact/>
                <PrivateRoute path='/users' component={Users} exact/>
                <PrivateRoute path='/vouchers' component={Vouchers} exact/>
                <PrivateRoute path='/orders' component={Orders} exact/>
                <PrivateRoute path='/menu' component={Menu} exact/>
                <PrivateRoute path='/restaurants' component={Restaurants} exact/>
                <PrivateRoute path='/statistics' component={Statistics} exact/>
                <PrivateRoute path='/statistics-new' component={StatisticsNew} exact/>
                <PrivateRoute path='/statistics-v2' component={StatisticsV2} exact/>
                <PrivateRoute path='/notifications' component={Notifications} exact/>
                <PrivateRoute path='/invoices' component={Invoices} exact/>
                <PrivateRoute path='/credit' component={Credit} exact/>
                <PrivateRoute path='/app-settings' component={() => (<Redirect to='/app-settings/aplicatie'/>)} exact/>
                <PrivateRoute path='/app-settings/aplicatie' component={AppSettingsAplicatie} exact/>
                <PrivateRoute path='/app-settings/taxe' component={AppSettingsTaxe} exact/>
                <PrivateRoute path='/app-settings/lista-neagra' component={AppSettingsBlacklist} exact/>
                <PrivateRoute path='/app-settings/bannere' component={AppSettingsBannere} exact/>
                <PrivateRoute path='/app-settings/targeturi' component={AppSettingsTargeturi} exact/>
                <PrivateRoute path='/app-settings/orase' component={AppSettingsOrase} exact/>
                <PrivateRoute path='/app-settings/roata' component={AppSettingsRoata} exact/>
                <Route component={NotFound}/>
              </Switch>
            </div>
          </Route>
        </Switch>
      </Router>
    </div>
  )
}

// Wraps the whole app in a real MUI theme driven by dark mode — every MUI
// component (Dialog, Menu/Popover, TextField, Button, IconButton, Switch...)
// picks up the right palette on its own via theme context, instead of each
// one needing its own hand-written dark-mode CSS override.
function ThemedApp() {
  const {darkMode} = useDarkMode();
  const theme = React.useMemo(() => createMuiTheme({
    palette: {
      type: darkMode ? 'dark' : 'light',
      primary: {main: '#DA7D46'},
      ...(darkMode ? {background: {default: '#000', paper: '#1c1c1c'}} : {}),
    },
  }), [darkMode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline/>
      <AppRoutes/>
    </ThemeProvider>
  );
}

export default function App() {
  return (
    <DarkModeProvider>
      <CityProvider>
        <ThemedApp/>
      </CityProvider>
    </DarkModeProvider>
  );
}
